<template>
  <div>
    <b-container>
      <div class="item-content">
        <b-row>
          <b-col class="sidebar-category" sm="6" md="4" lg="3">
            <div class="category">
              <h3 class="pt-2 pb-1 pl-3">Categories</h3>
                <treeselect v-model="selectedCateg" :multiple="true" 
                :options="schema.categories" :always-open="true" 
                placeholder="Select or Search..."   :max-height="800"/>
            </div>
          </b-col>
          <b-col class="main-content" sm="6" md="8" lg="9">
            <div class="header">
              <div class="p-2">
                <b-row>
                  <b-col>
                    <b-form-input placeholder="Silahkan ketik barang yang dicari"></b-form-input>
                  </b-col>
                  <b-col>
                    <b-row style="width:320px" class="float-right">
                      <b-col sm="3">
                        <label class="pt-2">Urutkan</label>
                      </b-col>
                      <b-col sm="9">
                        <b-form-select v-model="model.sortBy" :options="schema.sorts"></b-form-select>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="content">
              <b-row>
                <b-col
                  class="item-container"
                  md="6"
                  lg="4"
                  xl="3"
                  v-for="(item, idx) in schema.items"
                  :key="idx"
                >
                  <div class="item" @click="itemClick(item)">
                    <img :src="item.src" class="img-fluid" alt />
                    <div class="pt-0 pl-2 pr-2">
                      <em style="font-size:13px">{{item.itemname}}</em>
                      <br />
                      <em>[{{item.partnumber}}]</em>
                      <div class="price" v-if="(item.lastprice)">
                        <span>Rp {{item.lastprice | numFormat(',0')}}</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="footer">
              <div style="padding:5px 15px">
                <b-row>
                  <b-col>
                    Listing per page
                    <b-form-select  size="sm"
                      class="page-select ml-1 mr-1"
                      v-model="model.limit"
                      :options="schema.limit"
                    ></b-form-select>
                    {{itemMessage}}
                  </b-col>
                  <b-col>
                    <div class="text-right">
                      {{pageMessage}}
                      <b-form-select
                        class="page-select ml-1 mr-1"
                        v-model="model.page"
                        :options="schema.pages"
                      ></b-form-select>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-modal hide-footer v-model="schema.showDetail" :title="model.item.itemname" centered>
          <div class="item-detail">
            <div class="image-box">
              <b-carousel id="carousel-1" :interval="40000" controls indicators>
                <b-carousel-slide :img-src="img" v-for="img in model.item.images" :key="img"></b-carousel-slide>
              </b-carousel>
            </div>            
          </div>
                    <div class="pt-0 pl-2 pr-2">
                      <em style="font-size:13px">{{model.item.itemname}}</em>
                      <br />
                      <em>[{{model.item.partnumber}}]</em>
                      <div class="price" v-if="(model.item.lastprice)">
                        <span>Rp {{model.item.lastprice | numFormat(',0')}}</span>
                      </div>
                    </div>

          <b-row no-gutters>
            <b-col cols="4"> 
              <b-button
                class="mt-3"
                variant="outline-danger"
                block
                @click="addToCart"
              >Add To Cart</b-button>
            </b-col>
            <b-col cols="8">
                <b-form-input class="mt-3" v-model="model.item.description" placeholder="Add Specs/Description" ></b-form-input>
            </b-col>
          </b-row>
        </b-modal>
      </div>
    </b-container>
  </div>
</template>

<style lang="scss" scoped>
.item-content {
  .sidebar-category {
    height: calc(100vh - 50px);
    padding: 15px 10px 20px 10px;
    margin-top: -25px;

    .category {
      background-color: #fefefe;
      border-radius: 4px;
      border: 1px solid #ddd;
      height: 100%;
      overflow-y: auto;

      .list-group-item {
        border-left: none;
        border-right: none;

        &:first-child {
          border-radius: 0;
        }

        &:last-child {
          border-radius: 0;
        }
      }
    }
  }

  .main-content {
    height: calc(100vh - 50px);
    padding: 15px 10px 20px 10px;
    margin-top: -25px;

    .header {
      background-color: #fefefe;
      border: 1px solid #ddd;
      position: absolute;
      top: 15px;
      left: 5px;
      right: 5px;
      height: 58px;
      border-radius: 4px 4px 0 0;
      font-size: 13px;
      color: #333;
    }

    .content {
      background-color: #fefefe;
      border: 1px solid #ddd;
      padding: 10px 25px;
      overflow-y: auto;
      position: absolute;
      top: 80px;
      left: 5px;
      right: 5px;
      bottom: 65px;
    }

    .footer {
      background-color: #fefefe;
      border: 1px solid #ddd;
      position: absolute;
      height: 38px;
      left: 5px;
      right: 5px;
      bottom: 20px;
      border: 1px solid #ddd;
      border-radius: 0 0 4px 4px;
      font-size: 12px;

      .page-select {
        display: inline-block !important;
        width: 60px;
        margin-top: -1px;
      }
    }

    .item-container {
      padding: 8px;
      margin-bottom: 15px;

      &:before {
        content: "";
        display: block;
        padding-top: calc(100% + 90px);
      }

      .item {
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 0 0 20px;
        position: absolute;
        top: 5px;
        left: 8px;
        bottom: 5px;
        right: 8px;
        transition: 1.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        cursor: pointer;

        .price {
          font-size: 13px;
          margin-top: 5px;
          color: #ff5722;

          .price-discount {
            margin-left: 10px;
            font-size: 11px;
            background: #f02222;
            padding: 3px 7px;
            color: #fff;
            border-radius: 2px;
            margin-top: -10px;
          }
        }

        img {
          border-radius: 5px 5px 0 0;
        }

        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

  .item-detail {
    padding-top: 100%;

    .image-box {
      position: absolute;
      left: 16px;
      right: 16px;
      top: 16px;
    }
  }
}
</style>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import cartApi from "../../apis/item";
// import crud from "../../apis/crud";
import treetransform from "../../transformers/treeitemgroup";
import { setTimeout } from 'timers';

export default {
  components:{Treeselect},
  data() {
    return {
      selectedCateg: null,
      schema: {
        showDetail: false,
        sorts: [
          { value: 1, text: "Paling Sesuai" },
          { value: 2, text: "Nama barang" },
          { value: 3, text: "Terbaru" },
          { value: 4, text: "Stock Tertinggi" },
          { value: 5, text: "Stock Terendah" }
        ],
        limit: [10, 25, 50, 100],
        pages: [1, 2],
        items: [],
        categories: []
      },
      groups:[],
      model: {
        item: {},
        sortBy: 2,
        limit: 25,
        page: 1,
        total: 0,
        cats:[]
      }
    };
  },
  created() {
    this.initialize();
    this.$store.state.cart.display = 1;
    const lccart = JSON.parse(localStorage.getItem('cart'));
    if (lccart) {
      this.$store.commit('changeCartOwner', lccart.cartOwner);
      lccart.items.forEach((item)=>{
        this.$store.commit('addToCart', item);        
      });
    }
    if (this.$store.state.prevRoute.name=='budget.requestmaterial') {
        this.$store.commit('changeCartOwner', 'budget.requestmaterialfrm');
    } else if (this.$store.state.prevRoute.name=='app.requisition') {
        this.$store.commit('changeCartOwner', 'app.requisitionfrm');
    }
  },
  computed: {
    currLimit() {
      return this.model.limit;
    },
    currPage() {
      return this.model.page;
    },
    itemMessage() {
      const { model } = this;
      const { limit, page, total } = model;
      return `${limit * (page - 1)} - ${
        limit * page < total ? limit * page : total
      } of ${total} items`;
    },
    pageMessage() {
      const { model } = this;
      const { limit, page, total } = model;
      return `${page} of ${Math.ceil(total / limit)} pages`;
    }
  },
  watch: {
    currLimit() {
      this.model.page = 1;
      this.refresh();
    },
    currPage() {
      this.refresh();
    },
    selectedCateg(newVal) {
      this.model.cats=[];
      this.model.page=1;
      newVal.forEach((rw) => {
          const grpItem= this.groups.find(r=>r.id==rw);
          if (grpItem) {
             if (grpItem.judul=='Y'){
                const menus = this.groups.filter(r => (r.kode.startsWith(grpItem.kode) && (r.kode.localeCompare(grpItem.kode) == 1) && (r.judul!=='Y')));
                if (menus.length > 0) {
                  this.model.cats=menus.reduce((newArr,item) =>{
                    newArr.push(item.id);
                    return newArr;
                    },this.model.cats);
                }
             } else {
               this.model.cats.push(rw);
             }
          }
      });
      setTimeout(() => {
        this.refresh();
      }, 100);
    }    
  },
  destroyed() {
    this.$store.state.cart.display = 0;
  },
  methods: {
    async initialize() {
      // const { schema, model } = this;

      // const groups = await crud.list({
      //         tablename:'vwitemgroup',
      //         page: 1,
      //         limit: 1000,
      //         total: 0,
      //         sortBy: 'kode',
      //         sortDesc: false,
      //       });
      const groups = await cartApi.cataloggroup();
      this.groups= JSON.parse(JSON.stringify(groups));
      const categories = treetransform.list(groups);
      // this.itemImg[index].src=`${data.baseURL}/image/asset/${imgOnSvr[index].imgKey}`;

      const items = await cartApi.catalog(this.model);
      const { page, total, limit } = this.model;
      if (total && limit) {
        const max = Math.ceil(total / limit);
        const pages = [];
        for (let pg = 1; pg <= max; pg += 1) {
          pages.push(pg);
        }
        this.schema.pages = pages;
      }
      this.schema.categories = categories;
      this.schema.items = items;
      this.model.item = items[0];
    },
    async refresh() {
      const items = await cartApi.catalog(this.model);
      const { page, total, limit } = this.model;
      if (total && limit) {
        const max = Math.ceil(total / limit);
        const pages = [];
        for (let pg = 1; pg <= max; pg += 1) {
          pages.push(pg);
        }
        this.schema.pages = pages;
      }
      this.schema.items = items;
    },
    // categClick(id) {
    //   const { categories } = this;
    //   categories.forEach(m => {
    //     if (m.id === id) {
    //       m.active = true;
    //     } else {
    //       m.active = false;
    //     }
    //   });
    // },
    async itemClick(item) {
      // console.log(JSON.stringify(item));
      if (!(item.images)) {
          const images= await cartApi.itemimages(item);
          item.images = images; 
      }
      this.schema.showDetail = true;
      this.model.item = item;
    },
    addToCart() {
      this.schema.showDetail = false;
      // $store.commit("dimension", dims);
      this.$store.commit('addToCart', this.model.item)
      // console.log('--->', this.model.item);
      // this.$store.state.cart.items.push(this.model.item)
    }
  }
};
</script>
